module.exports = __webpack_public_path__ + "img/xld1.6ca1e289.png";